import React, { useContext, useState } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { constants, deviceDetect, UserContext } from '../utils';

export default function MobileDeviceSelect() {
  const userCtx = useContext(UserContext);
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);

  function onSetDevice() {
    deviceDetect.applyDevice(device, userCtx, navigate);
  };

  function setDeviceFirst(opt) {
    setDevice(opt);
  }

  return (
    <Container fluid className="pt-5">
      <div className="h4 mt-5 text-center">Please select your device</div>
      <Row className="justify-content-center">
        <Col xs={10} className="d-flex">
          <Select
            className="flex-fill"
            options={constants.DEVICE_TYPES}
            value={device}
            onChange={opt => setDeviceFirst(opt)}
          />
          <Button
            className="shredButton ms-2"
            disabled={device === null}
            onClick={onSetDevice}
          >
            Submit
          </Button>
        </Col>
      </Row>
    </Container>
  );
};